<template>
  <div class="settings" :style="`${btnKey === 'thirdparty' ? 'margin-top: 250px' : ''}`">
    <h1 v-html="title" @click="titleClick"></h1>
    <div style="margin-left: 20px; margin-top: 40px">
      <form-login
        v-if="btnKey === 'login'"
        :loginInfoForm="loginInfo"
        @login="loginClick"
        @thirdparty-click="thirdPartyClick"
        :isForm="false"
      ></form-login>
      <form-third-party
        v-if="btnKey === 'thirdparty'"
        :checked="enabled"
        @thirdparty-click="thirdPartyClick"
      ></form-third-party>
      <form-third-party-download
        v-if="btnKey === 'thirdpartydownload'"
        @thirdparty-click="thirdPartyClick"
        @thirdparty-checked-changed="checkedChanged"
      >
      </form-third-party-download>
    </div>
    <br />
    <!-- 远程登录 -->
    <div v-show="!showVnc && isVncVisible" style="border-top: 1px solid gray">
      <h1 style="margin-top: 40px">{{ $t("langcfg.textVnc") }}</h1>
      <div style="margin-top: 40px">
        <el-form label-position="center" :model="vncInfo" ref="vncInfo">
          <p>{{ $t("langcfg.textOpenVnc") }}</p>
          <br />
          <el-form-item>
            <div style="width: 100%; height: 60px">
              <el-button
                class="btn-oprator"
                @click="submitForm()"
                style="font-size: 25px; width: 150px"
              >
                {{
                  curLanguage === "zh_CN" ? $t("langcfg.txtOpen") : $t("langcfg.txtStart")
                }}</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 远程登录后的地址 -->
    <div v-show="showVnc && isVncVisible" style="height: 150px; border-top: 1px solid gray">
      <h1 style="margin-top: 10px">{{ $t("langcfg.textOpenVncSuccess") }}</h1>
      <p style="margin-top: 30px">
        {{ $t("langcfg.textServerAddress") }}: {{ ipv4 }}:6080/vnc.html
      </p>
    </div>
    <!-- 远程协助 -->
    <div style="border-top: 1px solid gray; margin-top: 20px">
      <h1 style="margin-top: 40px">
        {{ $t("langcfg.txtRemoteAssistance") }}
        <br /><span style="color: yellow; font-size: 20px">
          ( {{ $t("langcfg.txtForAfterSalesSupportOnly") }} )
        </span>
      </h1>

      <split-h :splitH="10"></split-h>

      <div style="margin-top: 40px">
        <el-form label-position="center" ref="vncInfo">
          <!-- <p>{{ $t('langcfg.txtOpenRemoteAssistance') }}</p> -->
          <!-- <br /> -->
          <el-form-item>
            <div style="width: 100%; height: 60px">
              <!-- <span style="float: left; font-size: 20px">{{ txtTip }}</span> -->
              <el-button
                class="btn-oprator"
                @click="showToDesk"
                style="font-size: 25px; width: 150px"
              >
                {{
                  curLanguage === "zh_CN" ? $t("langcfg.txtOpen") : $t("langcfg.txtStart")
                }}</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import login from "../../../services/login";
import FormLogin from "./FormLogin_old.vue";
import FormThirdParty from "./FormThirdParty.vue";
import FormThirdPartyDownload from "./FormThirdPartyDownload.vue";
import { isLocalServer, isStringEmpty, logStdout, objectCopy } from "../../../shared/utils";
import { LOGINSTATES } from "../../../shared/consts";
import { Message } from "../../../mixins";
import { saveServerSettings, saveSettings } from "../../../settings";
import EVENTS from "../../../bus";
import home from "../../../store/modules/home";
import fileSys from "../../../fileoprators/fileSystem";
const os = window.require("os");
const { exec, spawn } = window.require("child_process");
const { ipcRenderer } = window.require("electron");
let timeout;
export default {
  name: "Login",
  data() {
    return {
      labelPosition: "right",
      loginInfo: {
        username: "Admin",
        password: "",
        url: "127.0.0.1:8080",
        ssl: 0
      },
      txtTip: "",
      loginState: LOGINSTATES.undo,
      vncInfo: {
        password: "123456"
      },
      btnKey: "login",
      ipv4: null,
      showVnc: false,
      isVncVisible: false,
      connectArray: [],
      enabled: false,
      curLanguage: window.settings.language
    };
  },
  created() {
    const {
      username = "Admin",
      password = "",
      serverip = "127.0.0.1",
      serverport = 8080,
      serverssl = 0,
      sslport = 4430
    } = window.server;
    this.loginInfo = {
      username: username,
      password: "",
      url: `${serverip}:${serverport}`,
      ssl: serverssl,
      sslport: sslport
    };
  },
  mixins: [Message],
  methods: {
    ...mapActions({
      loginStateChanged: "home/loginStateChanged"
    }),
    ...mapMutations({
      vncStateChange: "home/VNC_CONTROL"
    }),
    checkedChanged(stat) {
      window.thirdPartySettings["auto"].value = false;
      this.enabled = stat;
      this.$bus.$emit("thirdparty-enabled", false);
    },
    titleClick() {
      if (this.btnKey === "thirdparty") {
        this.btnKey = "thirdpartydownload";
      }
    },
    thirdPartyClick(key) {
      this.btnKey = key;
      window.settings.thirdparty.enabled = this.btnKey === "thirdparty";
      window.settings.thirdparty.btnKey = this.btnKey;
      saveSettings(window.settings);
    },
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.loginInfo[key], (value) => {
        self.loginInfo[key] = value;
      });
    },
    handleVncPassword(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.vncInfo[key], (value) => {
        self.vncInfo[key] = value;
      });
    },
    submitForm() {
      this.ipv4 = this.getIpAddress();
      let vncServer = exec(
        "x0vncserver -display :0 -SecurityTypes=None -passwordfile ~/.vnc/passwd"
      );

      exec("/home/mw520/noVNC/utils/novnc_proxy --vnc localhost:5900", (err, stdout, stderr) => {
        if (!err) {
          logStdout("start vnc server", err.message);
        }
      });
      this.showVnc = true;
      vncServer.stderr.on("data", (data) => {
        if (data.includes("Connections: accepted")) {
          const timeStap = new Date().valueOf();
          this.connectArray.push(timeStap);
        }
        if (data.includes("Connections: closed")) {
          this.connectArray.pop();
        }
        if (this.connectArray.length > 0) {
          this.vncStateChange(true);
        }
        if (this.connectArray.length === 0) {
          this.vncStateChange(false);
        }
      });
    },
    getIpAddress() {
      let ifaces = os.networkInterfaces();

      for (let dev in ifaces) {
        let iface = ifaces[dev];

        for (let i = 0; i < iface.length; i++) {
          let { family, address, internal } = iface[i];

          if (family === "IPv4" && address !== "127.0.0.1" && !internal) {
            return address;
          }
        }
      }
    },
    showToDesk() {
      exec("killall ToDesk_SOS;pkill -9 ToDesk_SOS", function () {
        let sp = spawn("todesk_sos", {
          detached: true
        });
        sp.on("error", (err) => {
          if (err) {
            this.message(this.$t("langcfg.txtProcFailed"), "error", 2 * 1000);
          }
        });
        sp.stdout.on("data", (data) => {
          // this.message(this.$t('langcfg.txtProcFailed' + ':' + data), 'error', 2 * 1000)
        });
        sp.stderr.on("data", (data) => {
          logStdout("start todesk stderr", data.toString());
        });
      });
    },
    loginNotify(state) {
      if (state === "OK") {
        this.message(`${this.$t("langcfg.txtLoginSuccess")}`, "success", 2 * 1000);
      } else {
        this.message(`${this.$t("langcfg.txtLoginFailed")}`, "error", 2 * 1000);
      }
    },
    // setTipText (txt) {
    //   timeout = setTimeout(() => {
    //     this.txtTip = txt
    //   }, 200)
    // },
    procIPPort(url) {
      let arr = url.split(":");
      if (arr.length > 0) {
        return {
          ip: arr[0],
          port: arr[1]
        };
      } else {
        return {
          ip: "127.0.0.1",
          port: "8080"
        };
      }
    },
    loginClick(loginInfo) {
      this.loginInfo = loginInfo;
      if (isStringEmpty(this.loginInfo.username) || isStringEmpty(this.loginInfo.url)) {
        return;
      }
      // this.setTipText(this.$t('langcfg.txtLogging'))
      let cfg = {
        username: this.loginInfo.username,
        password: this.loginInfo.password,
        serverip: this.procIPPort(this.loginInfo.url).ip,
        serverport: this.procIPPort(this.loginInfo.url).port,
        serverssl: this.loginInfo.ssl,
        sslport: this.loginInfo.sslport
      };
      login(cfg, (data) => {
        clearTimeout(timeout);
        this.txtTip = "";
        this.loginNotify(data.message);
        window.server = cfg;
        saveServerSettings(window.server);
        if (data.message === "OK") {
          this.loginStateChanged(!isLocalServer());
          this.$bus.$emit(EVENTS.refreshPatients);
        } else {
          window.token = "";
          window.session = undefined;
          this.loginStateChanged(false);
        }
        // /
        this.sendChangeStatus(data.message, cfg);
      });
    },
    sendChangeStatus(state, cfg) {
      // /
      let send = null;
      if (this.isHasUrl) {
        send = "sendSetMsg2";
      } else {
        send = "sendSetMsg";
      }
      ipcRenderer.send(send, {
        type: "setMainFaceLogin",
        state: state,
        data: cfg
      });
    },
    // /
    watchSetStatus() {
      let _this = this;
      this.$bus.$on(EVENTS.setLogin, function (msg) {
        login(msg.data, (data) => {
          clearTimeout(timeout);
          _this.txtTip = "";
          _this.loginNotify(data.message);
          window.server = msg.data;
          saveServerSettings(window.server);
          if (data.message === "OK") {
            _this.loginStateChanged(!isLocalServer());
            _this.$bus.$emit(EVENTS.refreshPatients);
          } else {
            _this.loginStateChanged(false);
          }
        });
        // clearTimeout(timeout)
        // _this.txtTip = ''
        // _this.loginNotify(msg.state)
        // window.server = msg.data
        // saveServerSettings(window.server)
        // if (msg.state === 'OK') {
        //   _this.loginStateChanged(!isLocalServer())
        //   _this.$bus.$emit(EVENTS.refreshPatients)
        // } else {
        //   _this.loginStateChanged(false)
        // }
      });
    }
  },
  components: {
    FormLogin,
    FormThirdParty,
    FormThirdPartyDownload
  },
  mounted() {
    this.watchSetStatus();
    this.isVncVisible = fileSys.isFileExists("/home/mw520/noVNC");
    this.btnKey =
      window.settings.language !== "zh_CN" ? "login" : window.settings.thirdparty.btnKey;
    this.btnKey = this.btnKey && !isStringEmpty(this.btnKey) ? this.btnKey : "login";
    this.loginInfo = objectCopy(window.server);
  },
  beforeDestroy() {
    this.$bus.$off(EVENTS.setLogin);
  },
  computed: {
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    }),
    title() {
      switch (this.btnKey) {
        case "login":
          return this.$t("langcfg.txtLogin");
        case "thirdparty":
          return `<p>${this.$t("langcfg.txtThirdParty")} <span style="font-size:25px;color:rgb(64, 158, 255)">(${this.$t("langcfg.txtClick2ChangeComp")})</span></p>`;
        // return `<p>${this.$t('langcfg.txtThirdParty')}`
        case "thirdpartydownload":
          return `<p>${this.$t("langcfg.txtDownLoadScript")}`;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.settings {
  // margin-top: 60px;
  // margin-left: 60px;
  font-size: 23px;
  color: white;
  display: flex;
  align-items: left;
  flex-direction: column;
}

.el-form /deep/ .el-form-item__label {
  font-size: 30px;
  padding: 0px;
  line-height: 50px;
}

/deep/.el-form-item__error {
  margin-left: 20px;
}

.el-form-item {
  line-height: 40px;
  margin-top: 20px;
}

.Login {
  width: 800px;
  padding-left: 20px;
}

.login-tip {
  font-size: 20px;
  width: 100%;
  text-align: left;
  margin-left: 20px;
}

.login-tip-undo {
  color: white;
}

.login-tip-doing {
  color: white;
}

.login-tip-unlogined {
  color: white;
}

.login-tip-failed {
  color: white;
}

.protocol-url {
  display: inline-flex;
  width: 100%;
  margin-left: 20px;
  font-size: 20px;
}

.protocol {
  border: #dcdfe6;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-right: none;
  font-size: 30px;
  background: white;
  outline: none;
  height: 50px;
  color: #606266;
}

.url {
  width: 100%;
  border: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right: none;
  font-size: 30px;
  outline: none;
  height: 50px;
  color: #606266;
}

.btn-oprator {
  border: 1px gray solid;
  height: @header-fs+30px;
}

.btn-oprator:hover {
  color: @btn-hover-color;

  i {
    color: @btn-hover-color;
  }
}

.btn-oprator:active {
  background: @btn-active-color;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Login.vue